import Permissions from "@/constants/permissions";

const PageRouter = [

    /** 로그인 후 첫 화면. 사이드 메뉴 첫 항목과 같은 라우트 */
    {
        path: "managertnbox/dashboard",
        name: "managertnbox.dashboard",
        component: () => import('@/views/dashboard/Dashboard'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },
    {
        path: "managertnbox/dashboard/rank",
        name: "managertnbox.dashboard.rank",
        component: () => import('@/views/dashboard/CompanyRank'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },

    /** 회원관리 */
    {
        path: "managertnbox/membership/list",
        name: "managertnbox.membership.list",
        component: () => import('@/views/membership/MembershipList'), // 회원관리 리스트
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },
    {
        path: "managertnbox/erp-application/list",
        name: "managertnbox.erp-application.list",
        component: () => import('@/views/erp-application/ErpApplicationList'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },

    /** 다국어관리*/
    {
        path: "managertnbox/multilanguage/list",
        name: "managertnbox.multilanguage.list",
        component: () => import('@/views/multilanguage/MultilanguageList'), // 다국어 리스트
        meta: {
            permission: [Permissions.SYSTEM.TRANSLATE],
        },
    },

    /** 게시판 */
    {
        path: "managertnbox/notice/list",
        name: "managertnbox.notice.list",
        component: () => import('@/views/notice/NoticeList'),
        meta: {
            permission: [Permissions.SYSTEM.BOARD_NOTICE],
        },
    },
    {
        path: "managertnbox/notice/view/:id",
        name: "managertnbox.notice.view",
        component: () => import('@/views/notice/NoticeView'),
    },

    {
        path: "managertnbox/board/list",
        name: "managertnbox.board.list",
        component: () => import('@/views/board/BoardList'), // 공지사항 리스트
        meta: {
            permission: [Permissions.SYSTEM.BOARD_NOTICE]
        }
    },
    {
        path: "managertnbox/board/edit",
        name: "managertnbox.board.edit",
        component: () => import('@/views/board/BoardEdit'), // 공지사항 편집
        meta: {
            permission: [Permissions.SYSTEM.BOARD_NOTICE]
        }
    },

    {
        path: "managertnbox/board/faq/list",
        name: "managertnbox.board.faq.list",
        component: () => import('@/views/board/faq/FAQBoardList'), // FAQ 리스트
        meta: {
            permission: [Permissions.SYSTEM.BOARD_FAQ],
        },
    },
    {
        path: "managertnbox/board/faq/edit",
        name: "managertnbox.board.faq.edit",
        component: () => import('@/views/board/faq/FAQBoardEdit'), // FAQ 편집
        meta: {
            permission: [Permissions.SYSTEM.BOARD_NOTICE]
        }
    },
    /**
     * 새로운 메뉴얼 부분 라우팅 추가
     */
    {
        path: "managertnbox/board/newmanage",
        name: "managertnbox.board.newmanage",
        component: () => import('@/views/newManual/NewManual'),
        meta: {
            permission: [Permissions.SYSTEM.MANUAL_MANAGE],//기존 메뉴얼 권한 가져오기
        },
    },
    {
        path: "managertnbox/board/mobile-manual",
        name: "managertnbox.board.mobile-manual",
        component: () => import('@/views/mobileManual/MobileManual'),
        meta: {
            permission: [Permissions.SYSTEM.MANUAL_MANAGE],
        },
    },

    /** AI 관리 */
    {
        path: "managertnbox/ai-manage/call-history",
        name: "managertnbox.ai-manage.call-history",
        component: () => import('@/views/ai-manage/AiCallHistoryList'),
        meta: {
            permission: [Permissions.SYSTEM.MANUAL],
        },
    },
    {
        path: "managertnbox/ai-manage/credit-manage",
        name: "managertnbox.ai-manage.credit-manage",
        component: () => import('@/views/ai-manage/AiCreditManage'),
        meta: {
            permission: [Permissions.SYSTEM.MANUAL],
        },
    },


    /** 매뉴얼 */
    {
        path: "managertnbox/manual/manage",
        name: "managertnbox.manual.manage",
        component: () => import('@/views/manual/ManualManage'), // 매뉴얼 관리
        meta: {
            permission: [Permissions.SYSTEM.MANUAL_MANAGE],
        },
    },
    {
        path: "managertnbox/manual/item/manage/:name",
        name: "managertnbox.manual.item.manage",
        component: () => import('@/views/manual/ManualItemManage'), // 매뉴얼 컨텐츠 관리
        props: true,
        meta: {
            permission: [Permissions.SYSTEM.MANUAL_MANAGE],
        },
    },

    /** 담당자 이메일 */
    {
        path: "managertnbox/charge-email/signup",
        name: "managertnbox.charge-email.signup",
        component: () => import('@/views/charge-email/ChargeEmailSignupManage'),
        meta: {
            permission: [Permissions.SYSTEM.CHARGE_EMAIL],
        },
    },

    /** 시스템코드 */

    /** 모니터링 */
    {
        path: "managertnbox/monitoring/agent/deploy",
        name: "managertnbox.monitoring.agent.deploy",
        component: () => import('@/views/monitoring/MonitoringAgentDeploy'), // Agent 배포
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_DEPLOY],
        },
    },
    {
        path: "managertnbox/monitoring/version",
        name: "managertnbox.monitoring.version",
        component: () => import('@/views/monitoring/MonitoringManageVersion'), // Agent 버전 관리
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_VERSION_MANAGE],
        },
    },
    {
        path: "managertnbox/monitoring/agent/cycle/config",
        name: "managertnbox.monitoring.agent.cycle.config",
        component: () => import('@/views/monitoring/MonitoringAgentCycleConfig'), // Agent 전송 주기 설정
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_CYCLE_CONFIG],
        },
    },
    {
        path: "managertnbox/monitoring/agent/cycle/manage",
        name: "managertnbox.monitoring.agent.cycle.manage",
        component: () => import('@/views/monitoring/MonitoringAgentCycleManage'), // Agent 전송 주기 관리
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_CYCLE_MANAGE],
        },
    },
    {
        path: "managertnbox/monitoring/printer/series",
        name: "managertnbox.monitoring.printer.series",
        component: () => import('@/views/monitoring/printerSeries/NewMonitoringPrinterSeries'), // 프린터 시리즈
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_PRINTER_SERIES],
        },
    },
    {
        path: "managertnbox/monitoring/printer/driver",
        name: "managertnbox.monitoring.printer.driver",
        component: () => import('@/views/monitoring/printerDriver/PrinterDriverPackage'),
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_PRINTER_SERIES],
        },
    },
    {
        path: "managertnbox/monitoring/device/list",
        name: "managertnbox.monitoring.device.list",
        component: () => import('@/views/monitoring/deviceList/DeviceList'), //장치목록
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_PRINTER_SERIES],
        },
    },
    {
        path: "managertnbox/monitoring/device/list/detail/info",
        name: "managertnbox.monitoring.device.list.detail.info",
        component: () => import('@/views/monitoring/deviceList/DeviceDetail'), // 장치목록 -> 장치상세정보
        meta: {
            permission: [Permissions.SYSTEM.MONITORING_PRINTER_SERIES],
        },
    },
    {
        path: "managertnbox/monitoring/supply/status",
        name: "managertnbox.monitoring.supply.status",
        component: () => import('@/views/monitoring/supply/SupplyStatus'),
        meta: {
            // TODO: 테스트용 — 권한 DB 등록 후 Permissions.SYSTEM.MONITORING_SUPPLY 복구
            permission: null,
        },
    },
    {
        path: "managertnbox/monitoring/print-volume",
        name: "managertnbox.monitoring.print.volume",
        component: () => import('@/views/monitoring/print-volume/PrintVolume'),
        meta: {
            permission: null,
        },
    },


    /** 임대업체 */

    // 임대업체 관리
    {
        path: "managertnbox/rental-company/manager/data-migration",
        name: "managertnbox.rental-company.manager.data-migration",
        component: () => import('@/views/rental-company/manager/data-migration/DataMigrationWindow'), // 데이터 마이그레이션
    },

    //거래처 관리
    {
        path: "managertnbox/account/management",
        name: "managertnbox.account.management",
        component: () => import('@/views/accountManagement/accountManagement'),
        meta:{
            permission: [Permissions.SYSTEM.MANAGE_RENTAL]
        }// 데이터 마이그레이션
    },


    /** batch */

    // batch 확인
    {
        path: "managertnbox/batch",
        name: "managertnbox.batch",
        component: () => import('@/views/batch/BatchListComp'), // batch 확인
    },
    // batch 관리
    {
        path: "managertnbox/batchmanager",
        name: "managertnbox.batchmanager",
        component: () => import('@/views/batch/BatchManagerComp'), // batch 확인
    },

    /** sales */

    // 매출관리 관리
    {
        path: "managertnbox/sales",
        name: "managertnbox.sales",
        component: () => import('@/views/sales/SalesList'), // batch 확인
    },

    /** deposit */

    // 매출관리 관리
    {
        path: "managertnbox/deposit",
        name: "managertnbox.deposit",
        component: () => import('@/views/deposit/DepositList'),
    },


    /** 시스템 유저 */
    // 시스템 유저 목록
    {
        path: "managertnbox/sysuser/list",
        name: "managertnbox.sysuser.list",
        component: () => import('@/views/sysuser/SystemUserList'),
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_USER_LIST],
        },
    },
    // 시스템 유저 권한
    {
        path: "managertnbox/sysuser/permission/:adminUserId",
        name: "managertnbox.sysuser.permission",
        component: () => import('@/views/sysuser/SystemUserPermissionManage'),
        props: true,
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_USER],
        },
    },
    // 시스템 유저 등록
    {
        path: "managertnbox/sysuser/register",
        name: "managertnbox.sysuser.register",
        component: () => import('@/views/sysuser/SystemUserRegister'),
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_USER_REGISTER],
        },
    },

    /** 권한 */
    {
        path: "managertnbox/permission/system/manage",
        name: "managertnbox.permission.system.manage",
        component: () => import('@/views/permission/SystemPermissionManage'), // 시스템 권한 관리
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_PERMISSION_MANAGE],
        },
    },

    /** 권한 그룹 */
    {
        path: "managertnbox/permission-group/system/manage",
        name: "managertnbox.permission-group.system.manage",
        component: () => import('@/views/permission/SystemPermissionGroupManage'),
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_PERMISSION_GROUP_MANAGE],
        },
    },

    /** 시스템 그룹 권한 편집 */
    {
        path: "managertnbox/permission-group/system/manage/system/:id",
        name: "managertnbox.permission-group.system.manage.system",
        component: () => import('@/views/permission/SystemPermissionGroupManageDetailBySystem'),
        props: true,
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_PERMISSION_GROUP_MANAGE],
        },
    },

    /** 임대업체 그룹 권한 편집 */
    {
        path: "managertnbox/permission-group/system/manage/rentalcompany/:id",
        name: "managertnbox.permission-group.system.manage.rentalcompany",
        component: () => import('@/views/permission/SystemPermissionGroupManageDetailByRentalcompany'),
        props: true,
        meta: {
            permission: [Permissions.SYSTEM.SYSTEM_PERMISSION_GROUP_MANAGE],
        },
    },

    /** 임대업체 그룹 목록 */
    {
        path: "managertnbox/rental-company/manager/group/RentalCompanyGroupList",
        name: "managertnbox.rental-company.manager.group.rentalcompany-group-list",
        component: () => import('@/views/rental-company/manager/group/RentalCompanyGroupList.vue'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },
    /** 업무 대행 담당자 */
    {
        path: "managertnbox/rental-company/manager/agency-manager/AgencyManager",
        name: "managertnbox.rental-company.manager.agency-manager.agency-manager",
        component: () => import('@/views/rental-company/manager/agency-manager/AgencyManager.vue'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },

    /** 회원통계 */
    {
        path: "managertnbox/membership/stats",
        name: "managertnbox.membership.stats",
        component: () => import('@/views/membership/MembershipStats'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },

    /**
     * MPS 요금
     */
    {
        path: "managertnbox/payment/baseplan",
        name: "managertnbox.payment.baseplan",
        component: () => import('@/views/payment/BasePlan'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },
    {
        path: "managertnbox/payment/mps-usage",
        name: "managertnbox.payment.mps-usage",
        component: () => import('@/views/payment/MpsUsage'),
        meta: {
            permission: [Permissions.SYSTEM.MEMBERSHIP],
        },
    },
]

export default PageRouter;
